// Tool Kit Contents - Organized by storage location
export interface ToolKitSection {
    title: string
    items: Array<{ name: string; quantity: number | string }>
}

export const TOOL_KIT_CONTENTS: ToolKitSection[] = [
    {
        title: "Main box power tools",
        items: [
            { name: "Sawzall", quantity: 1 },
            { name: "Sawzall Blade Kit", quantity: 1 },
            { name: "Grinder", quantity: 1 },
            { name: "Circular Saw", quantity: 1 },
            { name: "Radio", quantity: 1 },
            { name: "Radio A/C cord", quantity: 1 },
            { name: "Oscillating Tool", quantity: 1 },
            { name: "Blower", quantity: 1 },
            { name: "Blower nozzles", quantity: 5 },
            { name: "Battery Charger", quantity: 2 },
            { name: "Drill", quantity: 1 },
            { name: "Impact Driver", quantity: 1 },
            { name: "Flashlight", quantity: 1 },
            { name: "Grinder Handle", quantity: 1 },
            { name: "20V 3-5 A battery", quantity: 4 },
            { name: "20V 2Ah Battery", quantity: 2 },
            { name: "Circ. Saw Blade", quantity: 1 },
            { name: "Grinder Blade", quantity: 1 },
        ],
    },
    {
        title: "Small orange box (power tools)",
        items: [
            { name: "Teflon tape", quantity: 1 },
            { name: "Wire Nuts (yellow)", quantity: 1 },
            { name: "Electrical tape", quantity: 1 },
            { name: "Pencils", quantity: 6 },
            { name: "Utility blades pack", quantity: 1 },
            { name: "Wrench for Grinder", quantity: 1 },
            { name: "Saws-all wood blade", quantity: 2 },
            { name: "Saws-all metal blade", quantity: 2 },
            { name: "Drywall bits", quantity: 4 },
            { name: "Torpedo Level", quantity: 1 },
            { name: "Oscillating blade Wood", quantity: 2 },
            { name: "Oscillating blade metal", quantity: 2 },
        ],
    },
    {
        title: "Main box hand tools",
        items: [
            { name: "Hammer", quantity: 4 },
            { name: "Flat Bar (Wonder Bar)", quantity: 4 },
            { name: "Utility Knives", quantity: 4 },
            { name: "Tape Measure", quantity: 4 },
            { name: "Multi-tip Screw Driver", quantity: 2 },
            { name: "Tri-square", quantity: 2 },
            { name: "Large Tri-square", quantity: 1 },
            { name: "Chalk Line", quantity: 1 },
            { name: "Chalk Bottle", quantity: 1 },
            { name: "Lineman Pliers", quantity: 1 },
            { name: "Channel-lock Pliers", quantity: 1 },
            { name: "Metal Snips", quantity: 1 },
            { name: "SAE Hex Key Set", quantity: 1 },
            { name: "Metric Hex Key Set", quantity: 1 },
            { name: "Star Hex Key Set", quantity: 1 },
            { name: "Drill and Driver Bit Set (small)", quantity: 1 },
            { name: "Drill & Driver Bit Set (Large)", quantity: 1 },
            { name: '6" Adjustable Wrench', quantity: 1 },
            { name: '10" Adjustable Wrench', quantity: 1 },
            { name: '12" Adjustable Wrench', quantity: 1 },
        ],
    },
    {
        title: "Small orange box (hand tools)",
        items: [
            { name: "Masks", quantity: "*3-4" },
            { name: "Ear Plugs", quantity: "*3-4" },
            { name: "Safety Glasses", quantity: 2 },
            { name: "Latex Gloves", quantity: 2 },
        ],
    },
]

export const TOOL_KIT_NAME = "Tool Kit"

// Helper function to check if a tool name matches "Tool Kit" with flexible spelling
export const isToolKit = (toolName: string): boolean => {
    if (!toolName) return false
    
    // Normalize: convert to lowercase and remove extra spaces
    const normalized = toolName.toLowerCase().trim().replace(/\s+/g, ' ')
    
    // Common variations to match
    const variations = [
        'tool kit',
        'toolkit',
        'took kit',
        'tookkit',
        'tool-kit',
        'tool kit contents',
        'tools kit',
        'toolskit',
    ]
    
    // Check if it matches any variation
    return variations.some(variant => normalized === variant || normalized.includes(variant))
}

// Helper function to sort tools so Tool Kit is always first
// Works with both string[] (for work scopes) and Array<{name: string, out: boolean, in: boolean}> (for work orders)
export const sortToolsWithToolKitFirst = <T extends string | { name: string }>(
    tools: T[]
): T[] => {
    if (!tools || tools.length === 0) return tools
    
    const toolKitItems: T[] = []
    const otherItems: T[] = []
    
    tools.forEach(tool => {
        const toolName = typeof tool === 'string' ? tool : tool.name
        if (isToolKit(toolName)) {
            toolKitItems.push(tool)
        } else {
            otherItems.push(tool)
        }
    })
    
    // Return Tool Kit items first, then all other items
    return [...toolKitItems, ...otherItems]
}

